export default __webpack_public_path__ + "static/media/Rez..bfd62a61.svg";